// Auto-generated from solutions-institutions.html. Verbatim redesign import. Do NOT edit.
export const STYLES = `

/* ===== PRODUCTION CSS BUNDLE ===== */
/* ===== production CSS bundle (index + light-system + animations) ===== */







/* T-REX Network — Brand color tokens (locked palette) */
:root {
  /* Locked palette (6 swatches) */
  --bone: #FAF8F4;
  --aubergine: #15102A;
  --aubergine-tier: #1A1531;
  --aubergine-raised: #221A42;
  --champagne: #A88B4A;
  --champ-light: #E8D9B8;
  --lava: #FF7A33;
  --signal-red: #C2281D;

  /* Marketing (dark) defaults - HSL values for shadcn */
  --background: 251 47% 12%;       /* aubergine */
  --foreground: 35 50% 97%;        /* bone */
  --card: 251 40% 14%;
  --card-foreground: 35 50% 97%;
  --popover: 251 40% 14%;
  --popover-foreground: 35 50% 97%;
  --primary: 38 39% 47%;            /* champagne */
  --primary-foreground: 251 47% 12%;
  --secondary: 251 40% 18%;
  --secondary-foreground: 35 50% 97%;
  --muted: 251 40% 18%;
  --muted-foreground: 35 25% 75%;
  --accent: 18 100% 60%;            /* lava */
  --accent-foreground: 251 47% 12%;
  --destructive: 5 76% 44%;         /* signal-red */
  --destructive-foreground: 35 50% 97%;
  --border: 251 30% 22%;
  --input: 251 30% 22%;
  --ring: 38 39% 47%;
  --radius: 6px;
}

/* Admin uses light theme via \`.admin-shell\` wrapper */
.admin-shell {
  --background: 35 35% 97%;         /* bone */
  --foreground: 251 47% 12%;        /* aubergine */
  --card: 0 0% 100%;
  --card-foreground: 251 47% 12%;
  --popover: 0 0% 100%;
  --popover-foreground: 251 47% 12%;
  --primary: 38 39% 47%;            /* champagne */
  --primary-foreground: 0 0% 100%;
  --secondary: 35 25% 92%;
  --secondary-foreground: 251 47% 12%;
  --muted: 35 25% 92%;
  --muted-foreground: 251 15% 35%;
  --accent: 18 100% 60%;            /* lava */
  --accent-foreground: 0 0% 100%;
  --destructive: 5 76% 44%;
  --destructive-foreground: 0 0% 100%;
  --border: 35 15% 85%;
  --input: 35 15% 85%;
  --ring: 38 39% 47%;
}

@layer base {
  html { -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; }
  body {
    margin: 0;
    background: var(--aubergine);
    color: var(--bone);
    font-family: "Inter", system-ui, sans-serif;
  }
  body.admin-body {
    background: var(--bone);
    color: var(--aubergine);
  }
}

/* Italic accent helper — tone-aware:
   - On night surfaces (and by default), use the lighter champ-light for readability.
   - On day/bone surfaces, switch to deeper champagne for legible contrast.        */
.accent-italic {
  font-family: "Bodoni Moda", Georgia, serif;
  font-style: italic;
  color: var(--champ-light);
}
.surface-day .accent-italic,
.admin-shell .accent-italic,
.bg-bone .accent-italic,
.bg-bone-soft .accent-italic { color: var(--champagne); }

/* When a marketing section is \`surface-day\`, descendant brand classes
   automatically flip to the day palette. This keeps existing markup intact:
   wrap with \`surface-day\` and you're done. */
.surface-day .text-bone        { color: var(--aubergine); }
.surface-day .text-bone\\/85    { color: rgba(21, 16, 42, 0.85); }
.surface-day .text-bone\\/80    { color: rgba(21, 16, 42, 0.8); }
.surface-day .text-bone\\/75    { color: rgba(21, 16, 42, 0.78); }
.surface-day .text-bone\\/70    { color: rgba(21, 16, 42, 0.72); }
.surface-day .text-bone\\/65    { color: rgba(21, 16, 42, 0.65); }
.surface-day .text-bone\\/60    { color: rgba(21, 16, 42, 0.6); }
.surface-day .text-bone\\/55    { color: rgba(21, 16, 42, 0.55); }
.surface-day .text-bone\\/45    { color: rgba(21, 16, 42, 0.45); }
.surface-day .text-bone\\/35    { color: rgba(21, 16, 42, 0.35); }
.surface-day .text-bone\\/30    { color: rgba(21, 16, 42, 0.30); }
.surface-day .text-champ-light { color: var(--champagne); }

.surface-day .bg-aubergine,
.surface-day .bg-aubergine-tier,
.surface-day .bg-aubergine-raised { background-color: var(--bone-soft); }

.surface-day .border-champ-light\\/10  { border-color: rgba(21, 16, 42, 0.10); }
.surface-day .border-champ-light\\/12  { border-color: rgba(21, 16, 42, 0.12); }
.surface-day .border-champ-light\\/15  { border-color: rgba(21, 16, 42, 0.15); }
.surface-day .border-champ-light\\/20  { border-color: rgba(21, 16, 42, 0.18); }
.surface-day .border-champagne\\/30,
.surface-day .border-champagne\\/40,
.surface-day .border-champagne\\/50    { border-color: rgba(168, 139, 74, 0.45); }
.surface-day .divide-champ-light\\/10 > * + * { border-color: rgba(21, 16, 42, 0.10); }
.surface-day .bg-champ-light\\/10      { background-color: rgba(21, 16, 42, 0.06); }

/* =========================================================
   Dark-surface gold legibility rule
   ---------------------------------------------------------
   The deeper champagne #A88B4A is too dark to read against
   aubergine. On every dark surface, promote text-champagne
   to text-champ-light (#E8D9B8). Hover effects on golden
   links/buttons resolve to bone-white (#FAF8F4).
   Applies to: .surface-night, .bg-aubergine, .bg-aubergine-tier
   (which cover hero, all night sections, all \`bg-aubergine\`
   wrappers on the home page, and inner-page dark wrappers).
   ========================================================= */
.surface-night .text-champagne,
.bg-aubergine .text-champagne,
.bg-aubergine-tier .text-champagne {
  color: var(--champ-light);
}
.surface-night .hover\\:text-champ-light:hover,
.surface-night .hover\\:text-champagne:hover,
.surface-night a.text-champagne:hover,
.surface-night button.text-champagne:hover,
.bg-aubergine .hover\\:text-champ-light:hover,
.bg-aubergine .hover\\:text-champagne:hover,
.bg-aubergine a.text-champagne:hover,
.bg-aubergine button.text-champagne:hover,
.bg-aubergine-tier .hover\\:text-champ-light:hover,
.bg-aubergine-tier .hover\\:text-champagne:hover {
  color: var(--bone);
}

/* =========================================================
   Light-surface golden link hover rule
   ---------------------------------------------------------
   On every light surface, base text-champagne MUST be
   #A88B4A (deep champagne). Override the broader dark-surface
   promoter from above when the gold sits in a day band, card,
   or bone wrapper. Hover lifts to #E8D9B8 for tactile contrast.
   ========================================================= */
.surface-day .text-champagne,
.bg-bone .text-champagne,
.bg-bone-soft .text-champagne,
.card-day .text-champagne {
  color: var(--champagne);
}
.surface-day a.text-champagne:hover,
.surface-day button.text-champagne:hover,
.surface-day .hover\\:text-champagne:hover,
.surface-day .hover\\:text-aubergine:hover,
.bg-bone a.text-champagne:hover,
.bg-bone button.text-champagne:hover,
.bg-bone .hover\\:text-champagne:hover,
.bg-bone .hover\\:text-aubergine:hover,
.bg-bone-soft a.text-champagne:hover,
.bg-bone-soft button.text-champagne:hover,
.card-day a.text-champagne:hover,
.card-day button.text-champagne:hover {
  color: var(--champ-light);
}

/* Inline SVG diagrams use #FAF8F4 (bone) as their stroke color on night surfaces.
   Inside day surfaces they should adopt aubergine. */
.surface-day svg [stroke="#FAF8F4"] { stroke: var(--aubergine) !important; }
.surface-day svg [fill="#FAF8F4"]   { fill:   var(--aubergine) !important; }
.surface-day svg [fill="#B8B0CC"]   { fill:   rgba(21, 16, 42, 0.6) !important; }

/* Editorial article prose */
.prose-trex {
  color: var(--bone);
  font-family: "Inter", system-ui, sans-serif;
  font-size: 1.0625rem;
  line-height: 1.75;
}
.prose-trex h1, .prose-trex h2, .prose-trex h3 {
  font-family: "Bodoni Moda", Georgia, serif;
  font-weight: 500;
  letter-spacing: -0.01em;
  margin-top: 2.5rem;
  margin-bottom: 1rem;
  color: var(--bone);
  scroll-margin-top: 110px; /* keep anchor jumps clear of the fixed Navbar */
}
.prose-trex h1 { font-size: 2.25rem; line-height: 1.15; }
.prose-trex h2 { font-size: 1.75rem; line-height: 1.2; }
.prose-trex h3 { font-size: 1.375rem; line-height: 1.3; }
.prose-trex p { margin: 1rem 0; color: rgba(250, 248, 244, 0.88); }
.prose-trex em { color: var(--champ-light); font-style: italic; }
.prose-trex strong { color: var(--bone); font-weight: 600; }
.prose-trex a { color: var(--champagne); text-decoration: underline; text-underline-offset: 3px; }
.prose-trex a:hover { color: var(--lava); }
.prose-trex blockquote { border-left: 3px solid var(--champagne); padding-left: 1.25rem; margin: 1.5rem 0; font-style: italic; color: rgba(250, 248, 244, 0.78); }
.prose-trex ul, .prose-trex ol { padding-left: 1.5rem; margin: 1rem 0; }
.prose-trex ul { list-style: disc; }
.prose-trex ul ul { list-style: circle; }
.prose-trex ol { list-style: decimal; }
.prose-trex li { margin: 0.5rem 0; color: rgba(250, 248, 244, 0.88); }
.prose-trex li::marker { color: var(--champagne); }
.prose-trex img { max-width: 100%; border-radius: 4px; margin: 1.5rem 0; }
.prose-trex hr { border: none; border-top: 1px solid rgba(232, 217, 184, 0.2); margin: 2.5rem 0; }
.prose-trex table { width: 100%; border-collapse: collapse; margin: 1.5rem 0; font-size: 0.95rem; }
.prose-trex th, .prose-trex td { padding: 0.6rem 0.8rem; border: 1px solid rgba(232, 217, 184, 0.15); text-align: left; }
.prose-trex th { background: rgba(232, 217, 184, 0.06); font-weight: 500; color: var(--bone); }
.prose-trex td { color: rgba(250, 248, 244, 0.85); }
.prose-trex code { font-family: "JetBrains Mono", monospace; font-size: 0.875em; background: rgba(168, 139, 74, 0.12); color: var(--champ-light); padding: 0.15em 0.4em; border-radius: 3px; }
.prose-trex pre { background: rgba(0, 0, 0, 0.25); border: 1px solid rgba(232, 217, 184, 0.12); border-radius: 6px; padding: 1rem 1.25rem; overflow-x: auto; margin: 1.25rem 0; }
.prose-trex pre code { background: transparent; padding: 0; color: var(--champ-light); font-size: 0.9rem; }
.prose-trex h2, .prose-trex h3 { scroll-margin-top: 6rem; }

/* ===========================================================================
   Reader theme (light) — applies on long-form pages (/articles/:slug, /docs/*)
   when the user toggles to light mode. Marketing pages are NOT affected.
   The \`.read-light\` class is set on the page wrapper; all descendant prose
   inverts to bone/aubergine while preserving the brand accents.
   =========================================================================== */
.read-light {
  background-color: var(--bone);
  color: var(--aubergine);
}
.read-light .prose-trex {
  color: rgba(21, 16, 42, 0.86);
}
.read-light .prose-trex h1,
.read-light .prose-trex h2,
.read-light .prose-trex h3 { color: var(--aubergine); }
.read-light .prose-trex p,
.read-light .prose-trex li { color: rgba(21, 16, 42, 0.85); }
.read-light .prose-trex em { color: var(--champagne); } /* deeper gold on bone */
.read-light .prose-trex strong { color: var(--aubergine); }
.read-light .prose-trex a { color: var(--champagne); }
.read-light .prose-trex a:hover { color: var(--lava); }
.read-light .prose-trex blockquote {
  border-left-color: var(--champagne);
  color: rgba(21, 16, 42, 0.78);
}
.read-light .prose-trex li::marker { color: var(--champagne); }
.read-light .prose-trex hr { border-top-color: rgba(21, 16, 42, 0.12); }
.read-light .prose-trex th,
.read-light .prose-trex td { border-color: rgba(21, 16, 42, 0.12); }
.read-light .prose-trex th {
  background: rgba(21, 16, 42, 0.04);
  color: var(--aubergine);
}
.read-light .prose-trex td { color: rgba(21, 16, 42, 0.85); }
.read-light .prose-trex code {
  background: rgba(168, 139, 74, 0.18);
  color: #6B5320;
}
.read-light .prose-trex pre {
  background: rgba(21, 16, 42, 0.04);
  border-color: rgba(21, 16, 42, 0.08);
}
.read-light .prose-trex pre code { color: var(--aubergine); }


/* Tiptap editor editing surface */
.tiptap-editor {
  min-height: 380px;
  outline: none;
  padding: 1.25rem 1.5rem;
  font-family: "Inter", system-ui, sans-serif;
  color: var(--aubergine);
  line-height: 1.7;
  font-size: 1rem;
}
.tiptap-editor h1, .tiptap-editor h2, .tiptap-editor h3 {
  font-family: "Bodoni Moda", Georgia, serif;
  font-weight: 500;
  letter-spacing: -0.01em;
  margin-top: 1.5rem;
  margin-bottom: 0.75rem;
}
.tiptap-editor h1 { font-size: 1.875rem; }
.tiptap-editor h2 { font-size: 1.5rem; }
.tiptap-editor h3 { font-size: 1.25rem; }
.tiptap-editor p { margin: 0.6rem 0; }
.tiptap-editor a { color: var(--champagne); text-decoration: underline; }
.tiptap-editor blockquote { border-left: 3px solid var(--champagne); padding-left: 1rem; color: #4b3f5c; }
.tiptap-editor ul, .tiptap-editor ol { padding-left: 1.5rem; margin: 0.6rem 0; }
.tiptap-editor ul { list-style: disc; }
.tiptap-editor ol { list-style: decimal; }
.tiptap-editor li { margin: 0.25rem 0; }
.tiptap-editor img { max-width: 100%; border-radius: 4px; }
.tiptap-editor p.is-editor-empty:first-child::before {
  content: attr(data-placeholder);
  color: rgba(21, 16, 42, 0.35);
  float: left; height: 0; pointer-events: none;
}

/* Hide scrollbar utility */
.no-scrollbar::-webkit-scrollbar { display: none; }
.no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }

/* Subtle vertical rule decoration */
.vrule {
  background: linear-gradient(to bottom, transparent, rgba(168, 139, 74, 0.35), transparent);
}

/* Glass card on aubergine */
.glass-night {
  background: rgba(26, 21, 49, 0.6);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(232, 217, 184, 0.08);
}


/* ===========================================================================
   STAGE 1 — Surface system + button physics (T-REX brand)
   - Two surface tones: \`night\` (aubergine) and \`day\` (bone).
   - One global light direction: upper-left (30% 30%).
   - Inset 1px highlight at top, inset 1px dark at bottom — never drop shadows
     except a soft champagne bloom on dark grounds.
   - Buttons always 4px radius. Never pill.
   =========================================================================== */

:root {
  --warm-black: #100A1F;     /* even warmer than aubergine, for occasional accent strips */
  --bone-soft: #F4EFE5;      /* day card surface */
  --bone-hairline: rgba(21, 16, 42, 0.08);
  --night-hairline: rgba(232, 217, 184, 0.10);
}

/* ---------- Section primitive ---------- */
.surface-night {
  background-color: var(--aubergine);
  color: var(--bone);
  position: relative;
  isolation: isolate;
}
.surface-day {
  background-color: var(--bone);
  color: var(--aubergine);
  position: relative;
  isolation: isolate;
}

/* Top hairline divider, drawn precisely 1px so it survives anti-aliasing */
.surface-night + .surface-day,
.surface-day + .surface-night,
.surface-day + .surface-day,
.surface-night + .surface-night {
  border-top: 1px solid transparent;
}
.surface-night { border-top-color: var(--night-hairline); }
.surface-day { border-top-color: var(--bone-hairline); }

/* Grain — a tiny SVG noise tile, applied at low opacity over each surface */
.surface-night::before,
.surface-day::before {
  content: "";
  position: absolute; inset: 0;
  pointer-events: none;
  background-image:
    url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.6 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>");
  background-size: 160px 160px;
  mix-blend-mode: overlay;
  z-index: 0;
}
.surface-night::before { opacity: 0.10; }
.surface-day::before { opacity: 0.045; }

/* Upper-left champagne bloom — ONLY on night surfaces, very gentle */
.surface-night.with-bloom::after {
  content: "";
  position: absolute;
  top: -10%; left: -5%;
  width: 60%; height: 80%;
  pointer-events: none;
  background: radial-gradient(ellipse at center,
    rgba(232, 217, 184, 0.10) 0%,
    rgba(168, 139, 74, 0.04) 35%,
    transparent 70%);
  filter: blur(20px);
  z-index: 0;
}

/* Ensure children sit above the grain/bloom */
.surface-night > *,
.surface-day > * { position: relative; z-index: 1; }

/* Section number eyebrow (typewriter mono, brand-specced) */
.section-eyebrow {
  display: inline-flex; align-items: baseline; gap: 0.75rem;
  font-family: "JetBrains Mono", ui-monospace, monospace;
  font-size: 11px;
  letter-spacing: 0.15em;
  text-transform: uppercase;
}
.surface-night .section-eyebrow { color: var(--champ-light); }
.surface-day .section-eyebrow { color: var(--champagne); }
.section-eyebrow .num {
  color: inherit;
  opacity: 0.7;
  font-weight: 500;
}

/* ---------- Brand buttons (radial-gradient + inset highlights) ---------- */
.btn-brand {
  display: inline-flex; align-items: center; justify-content: center;
  position: relative;
  padding: 0.75rem 1.5rem;
  min-height: 44px;
  border-radius: 4px;                /* RULE: 4px, never pill */
  font-family: "JetBrains Mono", ui-monospace, monospace;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.04em;
  line-height: 1;
  cursor: pointer;
  user-select: none;
  border: 0;
  transition: transform 180ms cubic-bezier(.2,.6,.2,1),
              filter 220ms ease,
              box-shadow 220ms ease;
  will-change: transform, filter;
}
.btn-brand:active { transform: translateY(1px) scale(0.997); }
.btn-brand:focus-visible {
  outline: none;
  box-shadow:
    inset 0 1px 0 rgba(255,255,255,0.45),
    inset 0 -1px 0 rgba(0,0,0,0.22),
    0 0 0 3px rgba(168, 139, 74, 0.35);
}
.btn-brand .arrow {
  display: inline-block;
  margin-left: 0.5rem;
  transition: transform 240ms cubic-bezier(.2,.6,.2,1);
}
.btn-brand:hover .arrow { transform: translateX(3px); }

/* Champagne · Day — matches homepage "Read our technical documentation" btn */
.btn-champagne-day {
  background-image: radial-gradient(ellipse at 30% 30%, #FBEFD0 0%, #E8D9B8 50%, #A88B4A 100%);
  color: #15102A;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.45),
    inset 0 -1px 0 rgba(92, 72, 36, 0.55),
    0 0 24px rgba(232, 217, 184, 0.20);
}
.btn-champagne-day:hover {
  filter: brightness(1.06);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.5),
    inset 0 -1px 0 rgba(92, 72, 36, 0.6),
    0 0 36px rgba(232, 217, 184, 0.32);
}

/* Champagne · Night — same physical material but lighter overall (champ-light
   dominant, brighter top-highlight) so the button reads cream/ivory on aubergine.
   Soft champagne bloom welds it to the dark surface. */
.btn-champagne-night {
  background: radial-gradient(ellipse at 30% 30%,
    #F6EDD0 0%,
    #E8D9B8 50%,
    #B89F6A 100%);
  color: #15102A;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.65),
    inset 0 -1px 0 rgba(0, 0, 0, 0.28),
    0 0 28px -8px rgba(232, 217, 184, 0.40);
}
.btn-champagne-night:hover {
  filter: brightness(1.04) saturate(1.05);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.7),
    inset 0 -1px 0 rgba(0, 0, 0, 0.32),
    0 0 40px -8px rgba(232, 217, 184, 0.55);
}

/* Lava · Day — transformation CTA on a bone surface */
.btn-lava-day {
  background: radial-gradient(ellipse at 30% 30%,
    #FFB48A 0%,
    #FF7A33 45%,
    #B83E18 100%);
  color: #FFFFFF;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.40),
    inset 0 -1px 0 rgba(0, 0, 0, 0.22),
    0 1px 0 rgba(21, 16, 42, 0.05);
}
.btn-lava-day:hover { filter: brightness(1.05) saturate(1.05); }

/* Lava · Night — "molten from the forge" */
.btn-lava-night {
  background: radial-gradient(ellipse at 30% 30%,
    #FFBE94 0%,
    #FF7A33 45%,
    #A8341A 100%);
  color: #FFFFFF;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.45),
    inset 0 -1px 0 rgba(0, 0, 0, 0.30),
    0 0 28px -8px rgba(255, 122, 51, 0.30);
}
.btn-lava-night:hover {
  filter: brightness(1.07) saturate(1.06);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.5),
    inset 0 -1px 0 rgba(0, 0, 0, 0.32),
    0 0 38px -8px rgba(255, 122, 51, 0.45);
}

/* Ghost (outline) — pairs with a primary champagne/lava button. NEVER glows. */
.btn-ghost-night {
  background: transparent;
  color: var(--champ-light);
  border: 1px solid rgba(232, 217, 184, 0.35);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
}
.btn-ghost-night:hover {
  border-color: var(--champ-light);
  background: rgba(232, 217, 184, 0.05);
}
.btn-ghost-day {
  background: transparent;
  color: var(--aubergine);
  border: 1px solid rgba(21, 16, 42, 0.18);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);
}
.btn-ghost-day:hover {
  border-color: var(--aubergine);
  background: rgba(21, 16, 42, 0.03);
}

/* Slightly tighter padding for "small" buttons (e.g. navbar) */
.btn-brand.btn-sm { padding: 0.5rem 1rem; min-height: 38px; font-size: 11px; }

/* ---------- Universal primary-button styling ----------
   Catch every legacy \`bg-champagne text-aubergine\` button across the site and
   give it the brand button physics. The night vs day palette is chosen by
   surface: on .surface-day descendants, use the deeper champagne; everywhere
   else (default = night), use the lighter champ-light dominant gradient.
   This means existing inline buttons get upgraded automatically — no need to
   convert every component. */
.bg-champagne.text-aubergine {
  background: radial-gradient(ellipse at 30% 30%,
    #F6EDD0 0%,
    #E8D9B8 50%,
    #B89F6A 100%) !important;
  color: #15102A !important;
  border-radius: 4px !important;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.65),
    inset 0 -1px 0 rgba(0, 0, 0, 0.28),
    0 0 28px -8px rgba(232, 217, 184, 0.40) !important;
  transition: filter 220ms ease, box-shadow 220ms ease, transform 180ms cubic-bezier(.2,.6,.2,1) !important;
}
.bg-champagne.text-aubergine:hover {
  filter: brightness(1.04) saturate(1.05) !important;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.7),
    inset 0 -1px 0 rgba(0, 0, 0, 0.32),
    0 0 40px -8px rgba(232, 217, 184, 0.55) !important;
}
.bg-champagne.text-aubergine:active { transform: translateY(1px) scale(0.997); }

/* On day surfaces, switch to the deeper champagne palette (still readable
   against bone, no overpowering bloom). */
.surface-day .bg-champagne.text-aubergine {
  background: radial-gradient(ellipse at 30% 30%,
    #E5C883 0%,
    #A88B4A 50%,
    #6B5530 100%) !important;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.55),
    inset 0 -1px 0 rgba(0, 0, 0, 0.22),
    0 1px 0 rgba(21, 16, 42, 0.06) !important;
}
.surface-day .bg-champagne.text-aubergine:hover {
  filter: brightness(1.05) saturate(1.04) !important;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.6),
    inset 0 -1px 0 rgba(0, 0, 0, 0.25),
    0 1px 0 rgba(21, 16, 42, 0.08) !important;
}

/* Hero ambient — concentric ledger rings drift very slowly */
@keyframes hero-ring-drift {
  0%   { transform: rotate(0deg)   scale(1); }
  50%  { transform: rotate(0.6deg) scale(1.02); }
  100% { transform: rotate(0deg)   scale(1); }
}
.hero-rings {
  animation: hero-ring-drift 24s ease-in-out infinite;
  transform-box: fill-box;
}

/* Mega-menu fade-down */
@keyframes fade-down {
  from { opacity: 0; transform: translateY(-4px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* Docs page loader — a diagonal wave traveling through a 5x5 grid of dots.
   Each dot animates with a stagger calculated from \`--i\` (row + column index)
   so the brightness sweeps from the top-left to the bottom-right and loops. */
@keyframes docs-loader-pulse {
  0%, 65%, 100% { opacity: 0.10; transform: scale(0.85); }
  30%           { opacity: 1;    transform: scale(1.25); }
}
.docs-loader-dot {
  animation: docs-loader-pulse 1.8s ease-in-out infinite;
  animation-delay: calc(var(--i, 0) * 70ms);
  transform-origin: center;
}
.docs-loader-caption {
  animation: docs-loader-caption 2.8s ease-in-out infinite;
}
@keyframes docs-loader-caption {
  0%, 100% { opacity: 0.35; letter-spacing: 0.25em; }
  50%      { opacity: 0.75; letter-spacing: 0.32em; }
}
@media (prefers-reduced-motion: reduce) {
  .docs-loader-dot, .docs-loader-caption { animation: none; opacity: 0.6; }
}

/* Home partners carousel — infinite horizontal marquee.
   The track holds the logo list twice (rendered side-by-side); we translate
   by exactly -50% so the second copy seamlessly takes over.
   Edge mask fades the strip into the background on both sides. */
@keyframes partners-marquee {
  from { transform: translateX(0); }
  to   { transform: translateX(-50%); }
}
.partners-marquee {
  display: flex;
  width: max-content;
  animation: partners-marquee 48s linear infinite;
  will-change: transform;
}
.partners-mask {
  -webkit-mask-image: linear-gradient(to right, transparent 0, #000 96px, #000 calc(100% - 96px), transparent 100%);
          mask-image: linear-gradient(to right, transparent 0, #000 96px, #000 calc(100% - 96px), transparent 100%);
}
@media (prefers-reduced-motion: reduce) {
  .partners-marquee { animation: none; transform: none; }
}

/* Fade-up (declared elsewhere already — kept here for cross-reference)
   .animate-fade-up { animation: fade-up 720ms cubic-bezier(.2,.6,.2,1) both; }
*/

/* =========================================================
   Home page band — when a shared section component is wrapped
   in a \`[data-testid^="home-band-"]\` div with a SectionBackground
   behind it, the inner section's own surface-day / surface-night
   solid background color would hide the SVG. Make the inner
   section's surface transparent so the SVG shows through. The
   grain overlay (::before) still applies for texture continuity.
   ========================================================= */
[data-testid^="home-band-"] > .relative > section {
  background-color: transparent !important;
}
[data-testid^="home-band-"] > .relative > section::before {
  opacity: 0 !important;
}

/* When multiple sections share one home-band-light wrapper, suppress the
   inner sections' top-hairline so the canvas reads as one continuous surface. */
[data-testid="home-band-light"] > .relative > section {
  border-top-color: transparent !important;
}

/* =========================================================
   Light-surface card primitive
   ---------------------------------------------------------
   Cards/panels sitting on a \`surface-day\` (bone) background.
   Tinted off-white #fefcf8 with hairline border #d8d0c2.
   ========================================================= */
.card-day {
  background-color: #fefcf8;
  border: 1px solid #d8d0c2;
}
.card-day-divide > * + * {
  border-top: 1px solid #d8d0c2;
}

/* =========================================================
   T-REX light system — opt-in utilities
   ---------------------------------------------------------
   Pair \`.lit-card\` with a \`.group\` parent. On group-hover the
   card gets:
     - a thin bottom-edge LED strip
     - a top sheen accent
     - icons inside \`.lit-icon\` glow softly
   All transitions are slow ( >= 320ms ) so it stays calm.
   ---------------------------------------------------------
   Respects prefers-reduced-motion (transitions disabled, no
   animations).
   ========================================================= */

.lit-card {
  position: relative;
  isolation: isolate;
  transition: border-color 320ms ease, box-shadow 480ms ease, transform 480ms ease;
}

/* Bottom LED edge — sits inside the card and lights up on hover */
.lit-card::after {
  content: "";
  position: absolute;
  left: 8%;
  right: 8%;
  bottom: 0;
  height: 1px;
  background: linear-gradient(
    to right,
    transparent 0%,
    rgba(232, 217, 184, 0) 10%,
    rgba(232, 217, 184, 0.65) 50%,
    rgba(232, 217, 184, 0) 90%,
    transparent 100%
  );
  opacity: 0;
  transition: opacity 420ms ease;
  pointer-events: none;
  z-index: 2;
}
.group:hover .lit-card::after,
.lit-card:hover::after {
  opacity: 1;
}

/* Soft warm halo bleeding below the LED — reads as the object emitting light */
.lit-card::before {
  content: "";
  position: absolute;
  left: 14%;
  right: 14%;
  bottom: -10px;
  height: 24px;
  background: radial-gradient(
    50% 100% at 50% 0%,
    rgba(232, 217, 184, 0.25),
    rgba(232, 217, 184, 0) 80%
  );
  opacity: 0;
  transition: opacity 480ms ease;
  pointer-events: none;
  z-index: 0;
}
.group:hover .lit-card::before,
.lit-card:hover::before {
  opacity: 1;
}

/* Icon "turns on" — any element marked .lit-icon emits warm light on parent hover */
.lit-icon {
  transition: filter 360ms ease, color 320ms ease;
}
.group:hover .lit-icon,
.lit-card:hover .lit-icon {
  filter: drop-shadow(0 0 6px rgba(232, 217, 184, 0.55))
          drop-shadow(0 0 12px rgba(168, 139, 74, 0.35));
}

/* =========================================================
   Section seam "light beam" — applied via \`.light-seam\` on
   any element that sits between two sections.
   A thin horizontal champagne gradient that breathes slowly.
   ========================================================= */
.light-seam {
  position: relative;
  height: 1px;
  background: linear-gradient(
    to right,
    transparent 0%,
    rgba(168, 139, 74, 0) 8%,
    rgba(232, 217, 184, 0.45) 50%,
    rgba(168, 139, 74, 0) 92%,
    transparent 100%
  );
  animation: light-seam-breathe 9s ease-in-out infinite;
}
@keyframes light-seam-breathe {
  0%, 100% { opacity: 0.35; }
  50%      { opacity: 0.85; }
}

/* =========================================================
   Hero light-speed beam — vertical pulse rising from below.
   Applied via \`.light-beam-rise\` on an absolutely positioned
   element behind hero copy.
   ========================================================= */
.light-beam-rise {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 220px;
  background: radial-gradient(
    ellipse 220px 60% at 50% 100%,
    rgba(232, 217, 184, 0.22),
    rgba(232, 217, 184, 0) 70%
  );
  filter: blur(8px);
  pointer-events: none;
  opacity: 0;
  animation: light-beam-rise 11s ease-in-out infinite;
}
@keyframes light-beam-rise {
  0%   { transform: translateY(20%);  opacity: 0; }
  20%  { opacity: 0.85; }
  60%  { opacity: 0.85; }
  100% { transform: translateY(-25%); opacity: 0; }
}

/* Respect reduced motion across the whole light system */
@media (prefers-reduced-motion: reduce) {
  .lit-card,
  .lit-card::after,
  .lit-card::before,
  .lit-icon,
  .light-seam,
  .light-beam-rise {
    transition: none !important;
    animation: none !important;
  }
}

/* =========================================================
   Reveal animations — opacity + small upward translate.
   ---------------------------------------------------------
   Used by:
     <Reveal>      ... </Reveal>       (single element)
     <RevealStack> ... </RevealStack>  (staggered children)
   ========================================================= */

.reveal,
.reveal-stack .reveal-item {
  opacity: 0;
  transform: translateY(22px);
  transition:
    opacity 720ms cubic-bezier(0.22, 0.65, 0.28, 1) var(--reveal-delay, 0ms),
    transform 720ms cubic-bezier(0.22, 0.65, 0.28, 1) var(--reveal-delay, 0ms);
  will-change: opacity, transform;
}

.reveal.is-revealed,
.reveal-stack.is-revealed .reveal-item {
  opacity: 1;
  transform: translateY(0);
}

/* Variant: subtle scale-in for emphasis cards (panels, hero cards). */
.reveal-scale {
  opacity: 0;
  transform: translateY(28px) scale(0.985);
  transition:
    opacity 800ms cubic-bezier(0.22, 0.65, 0.28, 1) var(--reveal-delay, 0ms),
    transform 800ms cubic-bezier(0.22, 0.65, 0.28, 1) var(--reveal-delay, 0ms);
  will-change: opacity, transform;
}
.reveal-scale.is-revealed {
  opacity: 1;
  transform: translateY(0) scale(1);
}

/* =========================================================
   Animated progress bar — drives width from 0 to a target
   value, set via inline CSS variable \`--progress-target\`.
   ========================================================= */
.progress-bar-fill {
  width: 0;
  transition: width 1800ms cubic-bezier(0.22, 0.65, 0.28, 1) 200ms;
}
.is-revealed .progress-bar-fill,
.progress-bar-fill.is-revealed {
  width: var(--progress-target, 0%);
}

/* =========================================================
   Reading progress bar (scroll indicator)
   Thin champagne hairline at the very top of the page, width
   tracks vertical scroll progress.
   ========================================================= */
.scroll-progress {
  position: fixed;
  top: 0;
  left: 0;
  height: 2px;
  width: var(--scroll-progress, 0%);
  background: linear-gradient(to right, rgba(168, 139, 74, 0), #E8D9B8 50%, #A88B4A);
  z-index: 100;
  pointer-events: none;
  transition: width 80ms linear;
}

/* =========================================================
   Subtle cursor-follow glow on \`surface-night\` sections.
   Activated by adding \`.cursor-glow\` to the section.
   ========================================================= */
.cursor-glow {
  position: relative;
}
.cursor-glow::after {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
  background: radial-gradient(
    320px circle at var(--cursor-x, -200px) var(--cursor-y, -200px),
    rgba(232, 217, 184, 0.10),
    transparent 60%
  );
  opacity: 0;
  transition: opacity 320ms ease;
}
.cursor-glow:hover::after { opacity: 1; }

/* Asset compliance card — staggered list reveal (the 5 PASS/VERIFIED lines) */
.live-asset-check {
  opacity: 0;
  transform: translateX(-8px);
  transition:
    opacity 520ms ease-out var(--reveal-delay, 0ms),
    transform 520ms ease-out var(--reveal-delay, 0ms);
}
.is-revealed .live-asset-check {
  opacity: 1;
  transform: translateX(0);
}

/* =========================================================
   Digit-by-digit reveal — editorial number animation.
   Each \`.digit-group\` slides up + fades in on its own delay,
   driven by \`--digit-delay\` set inline. Container \`.is-revealed\`
   gates the whole sequence.
   ========================================================= */
.digit-reveal { display: inline-block; }
.digit-reveal .digit-group {
  display: inline-block;
  opacity: 0;
  transform: translateY(0.18em);
  transition:
    opacity 520ms cubic-bezier(0.22, 0.65, 0.28, 1) var(--digit-delay, 0ms),
    transform 520ms cubic-bezier(0.22, 0.65, 0.28, 1) var(--digit-delay, 0ms);
}
.digit-reveal.is-revealed .digit-group {
  opacity: 1;
  transform: translateY(0);
}

/* Respect reduced motion globally for everything declared above */
@media (prefers-reduced-motion: reduce) {
  .reveal,
  .reveal-scale,
  .reveal-stack .reveal-item,
  .progress-bar-fill,
  .scroll-progress,
  .cursor-glow::after,
  .live-asset-check,
  .digit-reveal .digit-group {
    transition: none !important;
    opacity: 1 !important;
    transform: none !important;
  }
  .progress-bar-fill {
    width: var(--progress-target, 0%) !important;
  }
}

/* ===== SOLUTIONS-PAGE (ix-*) CSS ===== */
/* anchor-nav active state for translated pages */
.anchor-link.is-active{color:var(--champagne) !important}
/* ensure translated card-day works on day surfaces */
.card-day{background:var(--box-fill,#FEFCF8);border:1px solid var(--box-border,#D8D0C2)}

/* ===== FOR INSTITUTIONS — distinctive solutions layout ===== */
/* extravagant hero */
.ix-hero{position:relative;overflow:hidden;min-height:clamp(560px,82vh,760px);display:flex;align-items:center;isolation:isolate}
.ix-hero-canvas{position:absolute;inset:0;width:100%;height:100%;z-index:0;opacity:0.9}
.ix-hero-veil{position:absolute;inset:0;z-index:1;pointer-events:none;background:radial-gradient(ellipse 90% 70% at 18% 42%,rgba(21,16,42,0.66),transparent 70%),linear-gradient(180deg,rgba(21,16,42,0.30),transparent 30%,transparent 60%,rgba(21,16,42,0.55))}
/* cream (day) hero variant */
.ix-hero-day{background-color:var(--bone,#FAF8F4);background-image:radial-gradient(ellipse 72% 66% at 0% 0%,rgba(168,139,74,0.28),transparent 62%),radial-gradient(ellipse 80% 74% at 100% 100%,rgba(255,122,51,0.34),transparent 66%)}
.ix-hero-night{background-color:var(--aubergine,#15102A);background-image:radial-gradient(ellipse 72% 66% at 0% 0%,rgba(168,139,74,0.30),transparent 60%),radial-gradient(ellipse 80% 74% at 100% 100%,rgba(255,122,51,0.26),transparent 64%)}
.ix-hero-night .ix-hero-canvas{opacity:0.85}
.ix-hero-veil-night{background:radial-gradient(ellipse 70% 65% at 14% 42%,rgba(21,16,42,0.0),rgba(21,16,42,0.35) 86%),linear-gradient(180deg,transparent 58%,rgba(21,16,42,0.78))}
.ix-hero-night .ix-hero-eyebrow{color:var(--champ-light,#E8D9B8)}
.ix-hero-night .ix-hero-title{color:var(--bone,#FAF8F4)}
.ix-hero-night .ix-hero-sub{color:rgba(250,248,244,0.72)}
/* hero CTA overrides (institutions): white label on the primary, champagne outline on the ghost */
/* removed: white-text override — new champagne bg needs dark text */
.ix-hero .ix-hero-cta .btn-ghost-day{border-color:rgba(168,139,74,0.65);color:var(--aubergine,#15102A)}
.ix-hero .ix-hero-cta .btn-ghost-day:hover{border-color:#A88B4A;background:rgba(168,139,74,0.06)}
.ix-hero-day .ix-hero-canvas{opacity:0.6}
.ix-hero-veil-day{background:radial-gradient(ellipse 70% 65% at 14% 42%,rgba(250,248,244,0.0),rgba(250,248,244,0.30) 84%),linear-gradient(180deg,transparent 62%,rgba(250,248,244,0.7))}
.ix-hero-inner{position:relative;z-index:2;width:100%;padding-top:clamp(92px,15vh,138px);padding-bottom:clamp(52px,7vh,84px)}
.ix-hero-eyebrow{font-family:'JetBrains Mono',monospace;font-size:12px;font-weight:500;letter-spacing:0.24em;text-transform:uppercase;color:var(--champ-light,#E8D9B8);display:inline-flex;align-items:center;gap:12px}
.ix-hero-eyebrow::before{content:"";width:6px;height:6px;transform:rotate(45deg);background:currentColor;flex:0 0 auto}
/* diamond seal before every section eyebrow, matching the network pages */
.ix-eb{display:inline-flex;align-items:center;gap:12px}
.ix-eb::before{content:"";width:6px;height:6px;transform:rotate(45deg);background:currentColor;flex:0 0 auto}
/* champagne highlight on aubergine surfaces is ALWAYS light champagne */
.surface-night .text-champagne,.ix-hero-night .text-champagne,.with-bloom .text-champagne{color:var(--champ-light,#E8D9B8)}
.surface-night .ix-eb,.ix-hero-night .ix-eb,.with-bloom .ix-eb{color:var(--champ-light,#E8D9B8)}
.ix-hero-day .ix-hero-eyebrow{color:#8A6E3A}
.ix-hero-title{margin-top:22px;font-family:'Source Serif 4',serif;font-weight:400;line-height:1.06;letter-spacing:-0.02em;color:var(--bone,#FAF8F4)}
.ix-hero-day .ix-hero-title{color:var(--aubergine,#15102A)}
.ix-hero-l1,.ix-hero-l2b{display:block;font-size:clamp(38px,5.6vw,76px)}
@media(max-width:760px){.ix-hero-l1,.ix-hero-l2b{font-size:clamp(32px,8.4vw,52px)}}
.ix-hero-sub{margin-top:clamp(24px,3.5vh,38px);max-width:60ch;font-family:Inter,sans-serif;font-size:clamp(16px,1.4vw,19px);line-height:1.6;color:rgba(250,248,244,0.72)}
.ix-hero-day .ix-hero-sub{color:var(--on-surface-muted,#4F4538)}
.ix-hero-cta{margin-top:clamp(28px,4vh,40px);display:flex;flex-wrap:wrap;gap:14px}
.ix-hero-note{margin-top:18px;font-family:Inter,sans-serif;font-size:14px;color:var(--on-surface-muted,#4F4538)}
.ix-hero-note a{color:#8A6E3A;text-decoration:underline;text-underline-offset:3px}
.ix-hero-note a:hover{color:var(--aubergine,#15102A)}
/* featured apps (app-store only): dark-surface proof cards */
.app-search{position:relative;max-width:420px;margin:0 0 26px}
.app-search-ico{position:absolute;left:16px;top:50%;transform:translateY(-50%);width:17px;height:17px;color:rgba(232,217,184,0.5);pointer-events:none}
.app-search input{width:100%;font-family:Inter,sans-serif;font-size:14px;color:var(--bone,#FAF8F4);background:rgba(250,248,244,0.04);border:1px solid rgba(232,217,184,0.18);border-radius:999px;padding:12px 18px 12px 42px;outline:none;transition:border-color .3s,background .3s}
.app-search input::placeholder{color:rgba(250,248,244,0.4)}
.app-search input:focus{border-color:rgba(168,139,74,0.6);background:rgba(250,248,244,0.06)}
.app-search input::-webkit-search-cancel-button{-webkit-appearance:none}
.app-feat-empty{font-family:Inter,sans-serif;font-size:14px;color:rgba(250,248,244,0.5);margin-top:6px}
.app-feat-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:18px}
@media(max-width:880px){.app-feat-grid{grid-template-columns:1fr}}
.app-feat{position:relative;border:1px solid rgba(232,217,184,0.16);border-radius:14px;background:rgba(250,248,244,0.03);padding:28px 26px 30px;transition:border-color .4s,background .4s,box-shadow .4s}
.app-feat:hover{border-color:rgba(232,217,184,0.55);box-shadow:0 24px 50px -34px rgba(232,217,184,0.5)}
.app-feat-tag{display:inline-block;font-family:'JetBrains Mono',monospace;font-size:10px;letter-spacing:0.14em;text-transform:uppercase;color:var(--champ-light,#E8D9B8);border:1px solid rgba(232,217,184,0.3);border-radius:999px;padding:4px 11px;margin-bottom:18px}
.app-feat h3{font-family:'Source Serif 4',serif;font-weight:500;font-size:23px;color:var(--bone,#FAF8F4);margin-bottom:10px}
.app-feat p{font-family:Inter,sans-serif;font-size:14px;line-height:1.6;color:rgba(250,248,244,0.66)}
.app-feat-by{display:block;margin-top:18px;font-family:'JetBrains Mono',monospace;font-size:10px;letter-spacing:0.1em;text-transform:uppercase;color:rgba(232,217,184,0.5)}
/* ===== LEARN PAGE (overview hub) ===== */
.ix-entry-grid{display:grid;gap:16px;grid-template-columns:repeat(4,1fr)}
@media(max-width:980px){.ix-entry-grid{grid-template-columns:repeat(2,1fr)}}
@media(max-width:560px){.ix-entry-grid{grid-template-columns:1fr}}
.ix-entry{display:flex;flex-direction:column;text-decoration:none;background:rgba(255,255,255,0.45);border:1px solid #E2DACC;border-radius:14px;padding:26px;transition:border-color .35s cubic-bezier(.22,1,.36,1),box-shadow .35s,transform .35s}
.ix-entry:hover{border-color:#ff751c;box-shadow:0 24px 50px -34px rgba(255,117,28,0.5);transform:translateY(-3px)}
.ix-entry-num{font-family:'JetBrains Mono',monospace;font-size:11px;letter-spacing:0.18em;color:var(--champ,#A88B4A)}
.ix-entry-name{margin-top:14px;font-family:'Source Serif 4',serif;font-size:23px;font-weight:500;color:var(--aubergine,#15102A);line-height:1.15}
.ix-entry-teaser{margin-top:10px;font-family:Inter,sans-serif;font-size:14px;line-height:1.55;color:rgba(21,16,42,0.7);flex:1 1 auto}
.ix-entry-cta{margin-top:20px;font-family:'JetBrains Mono',monospace;font-size:11px;letter-spacing:0.16em;text-transform:uppercase;color:var(--champ,#A88B4A);display:inline-flex;align-items:center;gap:8px;text-decoration:none;transition:color .25s,gap .25s}
.ix-entry:hover .ix-entry-cta,.ix-entry-cta:hover{color:#ff751c;gap:12px}
.ix-flow{position:relative;display:grid;grid-template-columns:repeat(3,1fr);gap:28px}
@media(max-width:820px){.ix-flow{grid-template-columns:1fr;gap:22px}}
.ix-flow-rail{position:absolute;top:26px;left:8%;right:8%;height:1px;background:linear-gradient(90deg,rgba(232,217,184,0.5),rgba(255,117,28,0.55));opacity:0.5}
@media(max-width:820px){.ix-flow-rail{display:none}}
.ix-flow-step{position:relative}
.ix-flow-i{display:inline-flex;align-items:center;justify-content:center;width:52px;height:52px;border-radius:50%;border:1px solid rgba(168,139,74,0.5);background:var(--aubergine,#15102A);font-family:'JetBrains Mono',monospace;font-size:14px;color:var(--champ-light,#E8D9B8);position:relative;z-index:1}
.ix-flow-t{margin-top:18px;font-family:'Source Serif 4',serif;font-size:21px;font-weight:500;color:var(--bone,#FAF8F4);line-height:1.2}
.ix-flow-b{margin-top:9px;font-family:Inter,sans-serif;font-size:14px;line-height:1.6;color:rgba(250,248,244,0.66)}
.ix-art-grid{display:grid;gap:18px;grid-template-columns:repeat(3,1fr)}
@media(max-width:900px){.ix-art-grid{grid-template-columns:repeat(2,1fr)}}
@media(max-width:600px){.ix-art-grid{grid-template-columns:1fr}}
.ix-art{display:flex;flex-direction:column;text-decoration:none;border:1px solid #E2DACC;border-radius:14px;overflow:hidden;background:rgba(255,255,255,0.4);transition:border-color .35s,box-shadow .35s,transform .35s}
.ix-art:hover{border-color:#ff751c;box-shadow:0 24px 50px -34px rgba(255,117,28,0.45);transform:translateY(-3px)}
.ix-art-img{aspect-ratio:16/9;overflow:hidden;background:linear-gradient(135deg,#efe7d6,#e3d7bd);display:flex;align-items:center;justify-content:center}
.ix-art-img img{width:100%;height:100%;object-fit:cover;transition:transform .5s cubic-bezier(.22,1,.36,1)}
.ix-art:hover .ix-art-img img{transform:scale(1.04)}
.ix-art-ph{font-family:'Source Serif 4',serif;font-style:italic;font-size:24px;color:rgba(138,110,58,0.5)}
.ix-art-body{padding:22px}
.ix-art-cat{font-family:'JetBrains Mono',monospace;font-size:10px;letter-spacing:0.15em;text-transform:uppercase;color:var(--champ,#A88B4A)}
.ix-art-title{margin-top:10px;font-family:'Source Serif 4',serif;font-size:19px;font-weight:500;color:var(--aubergine,#15102A);line-height:1.25}
.ix-art-ex{margin-top:9px;font-family:Inter,sans-serif;font-size:13.5px;line-height:1.55;color:rgba(21,16,42,0.66);display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}
.ix-art-date{margin-top:14px;font-family:'JetBrains Mono',monospace;font-size:10px;letter-spacing:0.12em;text-transform:uppercase;color:rgba(21,16,42,0.45)}
.ix-term-grid{display:grid;gap:14px;grid-template-columns:repeat(3,1fr);align-items:stretch}
@media(max-width:900px){.ix-term-grid{grid-template-columns:repeat(2,1fr)}}
@media(max-width:560px){.ix-term-grid{grid-template-columns:1fr}}
.ix-term{display:flex;flex-direction:column;height:100%;min-height:150px;background:rgba(255,255,255,0.4);border:1px solid #E2DACC;border-radius:12px;padding:22px;transition:border-color .35s}
.ix-term:hover{border-color:var(--champ,#A88B4A)}
.ix-term-t{font-family:'JetBrains Mono',monospace;font-size:13px;letter-spacing:0.04em;color:var(--aubergine,#15102A);font-weight:500}
.ix-term-b{margin-top:9px;font-family:Inter,sans-serif;font-size:13px;line-height:1.55;color:rgba(21,16,42,0.68)}
.ix-ai-grid{display:grid;grid-template-columns:1fr 1.15fr;gap:clamp(28px,5vw,64px);align-items:center}
@media(max-width:920px){.ix-ai-grid{grid-template-columns:1fr;gap:36px}}
.ix-ai-card{background:rgba(255,255,255,0.5);border:1px solid #E2DACC;border-radius:16px;padding:30px}
.ix-ai-card-night{background:rgba(250,248,244,0.045);border-color:rgba(232,217,184,0.42);border-radius:16px;box-shadow:0 0 50px -18px rgba(232,217,184,0.4),inset 0 1px 0 rgba(250,248,244,0.06)}
.ix-ai-head{display:flex;align-items:center;gap:10px;margin-bottom:20px}
.ix-ai-label{font-family:'JetBrains Mono',monospace;font-size:10px;letter-spacing:0.2em;text-transform:uppercase;color:rgba(21,16,42,0.55)}
.ix-ai-label-night{color:rgba(232,217,184,0.6)}
.ix-ai-try{font-family:Inter,sans-serif;font-size:13px;color:rgba(21,16,42,0.5);margin:0 0 12px}
.ix-ai-try-night{color:rgba(250,248,244,0.5)}
.ix-ai-qs{display:flex;flex-direction:column;gap:9px;margin-bottom:22px}
.ix-ai-q{display:flex;align-items:center;gap:10px;border:1px solid rgba(250,248,244,0.12);background:rgba(250,248,244,0.03);border-radius:10px;padding:14px 16px;font-family:Inter,sans-serif;font-size:13.5px;color:rgba(250,248,244,0.82);text-decoration:none;transition:border-color .28s cubic-bezier(.22,1,.36,1),background .28s,color .28s,transform .28s}
.ix-ai-q:hover{border-color:rgba(232,217,184,0.55);background:rgba(232,217,184,0.08);color:#FAF8F4;transform:translateX(3px)}
.ix-ai-q:hover .ix-ai-caret{color:var(--champ-light,#E8D9B8)}
.ix-ai-caret{font-family:'JetBrains Mono',monospace;color:var(--champ,#A88B4A);font-size:14px}
.ix-ai-card-night .ix-ai-caret{color:var(--champ-light,#E8D9B8)}
.ix-ai-go{display:inline-flex;align-items:center;gap:8px;background:var(--champ,#A88B4A);color:var(--bone,#FAF8F4);border-radius:9px;padding:13px 20px;font-family:'JetBrains Mono',monospace;font-size:12px;letter-spacing:0.05em;text-decoration:none;transition:background .25s,gap .25s}
.ix-ai-go:hover{background:#ff751c;gap:12px}
.ix-res-grid{display:grid;gap:16px;grid-template-columns:repeat(3,1fr)}
@media(max-width:820px){.ix-res-grid{grid-template-columns:1fr}}
.ix-res{display:flex;flex-direction:column;text-decoration:none;background:rgba(255,255,255,0.45);border:1px solid #E2DACC;border-radius:14px;padding:26px;transition:border-color .35s,box-shadow .35s,transform .35s}
.ix-res:hover{border-color:#ff751c;box-shadow:0 22px 48px -34px rgba(255,117,28,0.45);transform:translateY(-2px)}
.ix-res-top{display:flex;align-items:center;justify-content:space-between;margin-bottom:14px}
.ix-res-tag{font-family:'JetBrains Mono',monospace;font-size:10px;letter-spacing:0.16em;text-transform:uppercase;color:var(--champ,#A88B4A)}
.ix-res-ext{font-size:15px;color:var(--champ,#A88B4A);transition:color .25s,transform .25s}
.ix-res:hover .ix-res-ext{color:#ff751c;transform:translate(2px,-2px)}
.ix-res-t{font-family:'Source Serif 4',serif;font-size:20px;font-weight:500;color:var(--aubergine,#15102A);line-height:1.2}
.ix-res-b{margin-top:9px;font-family:Inter,sans-serif;font-size:13.5px;line-height:1.55;color:rgba(21,16,42,0.68)}
/* FAQ accordion (app-store) — matches network pages: native details/summary */
.ix-faq{max-width:820px;margin:0 auto;border-top:1px solid rgba(168,139,74,0.22)}
.ix-faq-item{border-bottom:1px solid rgba(168,139,74,0.22)}
.ix-faq-item summary{list-style:none;cursor:pointer;position:relative;padding:clamp(18px,2.2vw,24px) 40px clamp(18px,2.2vw,24px) 0;font-family:'Source Serif 4',serif;font-weight:500;font-size:clamp(16px,1.6vw,19px);color:var(--aubergine,#15102A);transition:color .3s cubic-bezier(0.22,1,0.36,1)}
.ix-faq-item summary:hover{color:#ff751c}
.ix-faq-item summary::-webkit-details-marker{display:none}
.ix-faq-item summary::after{content:"+";position:absolute;right:6px;top:50%;transform:translateY(-50%);font-family:'JetBrains Mono',monospace;font-size:20px;color:#A88B4A;transition:transform .3s cubic-bezier(0.22,1,0.36,1),color .3s}
.ix-faq-item summary:hover::after{color:#ff751c;transform:translateY(-50%) rotate(90deg)}
.ix-faq-item[open] summary::after{content:"−"}
.ix-faq-item[open] summary:hover::after{transform:translateY(-50%) rotate(180deg)}
.ix-faq-a{padding:0 40px clamp(20px,2.4vw,26px) 0;font-family:Inter,sans-serif;font-size:14px;line-height:1.62;color:var(--on-surface-muted,#4F4538);max-width:68ch}
.ix-faq-a a{color:#8A6E3A;text-decoration:underline;text-underline-offset:3px;text-decoration-thickness:1px;transition:color .25s}
.ix-faq-a a:hover{color:#ff751c}
.ix-hero-stats{margin-top:clamp(40px,6vh,64px);display:grid;grid-template-columns:repeat(4,auto);gap:0;justify-content:start}
@media(max-width:760px){.ix-hero-stats{grid-template-columns:repeat(2,1fr);row-gap:26px}}
.ix-hs{padding:2px clamp(22px,2.6vw,40px)}
.ix-hs:first-child{padding-left:0}
.ix-hs + .ix-hs{border-left:1px solid rgba(232,217,184,0.18)}
.ix-hero-day .ix-hs + .ix-hs{border-left:1px solid var(--box-border,#D8D0C2)}
@media(max-width:760px){.ix-hs:nth-child(3){border-left:0;padding-left:0}}
.ix-hs .v{font-family:'Source Serif 4',serif;font-weight:400;font-size:clamp(28px,3.4vw,46px);line-height:1;letter-spacing:-0.02em;color:var(--bone,#FAF8F4);white-space:nowrap}
.ix-hero-day .ix-hs .v{color:var(--aubergine,#15102A)}
.ix-hs .v .cur{font-style:italic;color:var(--champ-light,#E8D9B8)}
.ix-hero-day .ix-hs .v .cur{color:#A88B4A}
.ix-hs .k{margin-top:10px;font-family:'JetBrains Mono',monospace;font-size:10px;letter-spacing:0.13em;text-transform:uppercase;color:rgba(250,248,244,0.5);max-width:18ch}
.ix-hero-day .ix-hs .k{color:var(--on-surface-muted,#4F4538)}
/* cycling role word in the headline (own mechanic, light surface) */
.ix-cyc{position:relative;display:inline-block;vertical-align:bottom;height:1.16em;overflow:hidden;transition:width 420ms cubic-bezier(0.22,1,0.36,1)}
.ix-cyc-track{display:block;position:relative;height:100%;width:100%}
.ix-cyc .w{position:absolute;left:0;bottom:0;white-space:nowrap;padding:0 0.04em;font-style:italic;line-height:1.16em;background:linear-gradient(100deg,#C9A24B 0%,#A88B4A 50%,#8A6E3A 100%);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;opacity:0;transform:translateY(0.24em);transition:opacity 360ms cubic-bezier(0.22,1,0.36,1),transform 360ms cubic-bezier(0.22,1,0.36,1);pointer-events:none}
.ix-cyc .w.is-in{opacity:1;transform:none}
.ix-cyc .w.is-out{opacity:0;transform:translateY(-0.24em)}
.ix-hero-night .ix-cyc .w{background:none;-webkit-background-clip:initial;background-clip:initial;-webkit-text-fill-color:initial;color:var(--champ-light,#E8D9B8)}
.ix-cyc-measure{position:absolute;visibility:hidden;height:0;overflow:hidden;white-space:nowrap;font-style:italic;padding:0 0.04em;font-family:'Source Serif 4',serif;font-weight:400}
@media(max-width:760px){.ix-cyc{width:auto !important}}
.ix-hero-l1{line-height:1.08;white-space:nowrap}
@media(max-width:760px){.ix-hero-l1{white-space:normal}}
.ix-hero .reveal-up{opacity:0;transform:translateY(26px);animation:ixHeroUp .9s cubic-bezier(0.22,1,0.36,1) forwards}
.ix-hero .ix-hero-eyebrow{animation-delay:.05s}
.ix-hero .ix-hero-l1{animation-delay:.14s}
.ix-hero .ix-hero-l2b{animation-delay:.26s}
.ix-hero .ix-hero-sub{animation-delay:.4s}
.ix-hero .ix-hero-cta{animation-delay:.5s}
@keyframes ixHeroUp{to{opacity:1;transform:none}}
@media(prefers-reduced-motion:reduce){.ix-hero .reveal-up{animation:none;opacity:1;transform:none}}
.ix-scope .reveal-up{opacity:0;transform:translateY(22px);transition:opacity .7s cubic-bezier(0.22,1,0.36,1),transform .7s cubic-bezier(0.22,1,0.36,1)}
.ix-scope .reveal-up.in{opacity:1;transform:none}
/* asset-class grid: offset masonry-ish, animated accent bar + corner motif */
.ix-aclass-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:18px}
@media(max-width:900px){.ix-aclass-grid{grid-template-columns:repeat(2,1fr)}}
@media(max-width:600px){.ix-aclass-grid{grid-template-columns:1fr}}
.ix-aclass{position:relative;overflow:hidden;border:1.5px solid var(--box-border,#D8D0C2);border-radius:10px;background:var(--box-fill,#FEFCF8);padding:26px 26px 56px;transition:box-shadow .4s cubic-bezier(0.22,1,0.36,1),border-color .4s cubic-bezier(0.22,1,0.36,1)}
.ix-aclass:hover{border-color:#ff751c;box-shadow:0 24px 50px -32px rgba(255,117,28,0.4)}
/* (legacy ring element, no longer rendered) */
.ix-aclass .ix-bar{display:none}
.ix-aclass h3{font-family:'Source Serif 4',serif;font-weight:500;font-size:21px;color:var(--aubergine,#15102A);margin-bottom:8px}
.ix-aclass p{font-family:Inter,sans-serif;font-size:14px;line-height:1.6;color:var(--on-surface-muted,#4F4538)}
.ix-aclass .ix-motif{position:absolute;right:12px;bottom:12px;width:60px;height:60px;color:#A88B4A;opacity:.32}
.ix-aclass .ix-motif svg{width:100%;height:100%;stroke-linecap:round;stroke-linejoin:round}
/* operating model: horizontal stepper (node + connector segments), hover highlights step */
.ix-stepper{display:grid;grid-template-columns:repeat(4,1fr);align-items:stretch}
@media(max-width:820px){.ix-stepper{grid-template-columns:repeat(2,1fr);row-gap:18px}}
@media(max-width:480px){.ix-stepper{grid-template-columns:1fr}}
.ix-step{position:relative;padding:0 8px;display:flex;flex-direction:column}
.ix-step-track{position:relative;display:flex;align-items:center;justify-content:center;height:58px;margin-bottom:22px;flex:0 0 auto}
.ix-step-line{position:absolute;top:50%;height:2px;transform:translateY(-1px);background:rgba(232,217,184,0.16)}
.ix-step-line.ix-line-before{left:0;right:50%;margin-right:29px}
.ix-step-line.ix-line-after{right:0;left:50%;margin-left:29px}
.ix-step:first-child .ix-line-before{display:none}
.ix-step:last-child .ix-line-after{display:none}
/* node: champagne ring at rest; on hover/active the whole circle glows light champagne (no orange fill) */
.ix-step-node{position:relative;z-index:2;width:58px;height:58px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:rgba(250,248,244,0.03);border:1px solid rgba(232,217,184,0.32);font-family:'JetBrains Mono',monospace;font-size:14px;color:rgba(232,217,184,0.72);box-shadow:0 1px 0 rgba(255,255,255,0.05) inset;transition:border-color .45s,color .45s,box-shadow .45s,background .45s,transform .45s}
/* boxed card: homepage 'who it's for' panel material, equal height */
.ix-step-card{flex:1 1 auto;text-align:center;padding:24px 20px 26px;border:1px solid rgba(250,248,244,0.12);border-radius:14px;background:rgba(250,248,244,0.02);transition:transform .45s cubic-bezier(0.22,1,0.36,1),border-color .45s,box-shadow .45s,background .45s}
.ix-step-tag{display:inline-block;font-family:'JetBrains Mono',monospace;font-size:10px;letter-spacing:0.12em;text-transform:uppercase;color:rgba(232,217,184,0.55);margin-bottom:10px;opacity:0;transform:translateY(4px);transition:opacity .4s,transform .4s,color .4s}
.ix-step-card h3{font-family:'Source Serif 4',serif;font-weight:500;font-size:21px;color:var(--bone,#FAF8F4);margin-bottom:8px;transition:color .4s}
.ix-step-card p{font-family:Inter,sans-serif;font-size:14px;line-height:1.6;color:rgba(250,248,244,0.62);max-width:30ch;margin:0 auto}
/* done (steps before the hovered one): champagne ring brightens, lava connector */
.ix-step.done .ix-step-node{border-color:rgba(232,217,184,0.6);color:var(--champ-light,#E8D9B8);background:rgba(232,217,184,0.06)}
.ix-step.done .ix-line-before,.ix-step.done .ix-line-after,.ix-step.active .ix-line-before{background:linear-gradient(90deg,#FF7A33,#FF9A5A)}
/* active (hovered): circle glows light champagne; box lifts and warms its border */
.ix-step.active .ix-step-node{border-color:var(--champ-light,#E8D9B8);color:var(--champ-light,#E8D9B8);background:rgba(232,217,184,0.10);box-shadow:0 0 30px -4px rgba(232,217,184,0.6);transform:scale(1.06)}
.ix-step.active .ix-step-card{transform:translateY(-4px);border-color:rgba(232,217,184,0.42);background:rgba(250,248,244,0.045)}
.ix-step.active .ix-step-tag{opacity:1;transform:none;color:var(--champ-light,#E8D9B8)}
.ix-step.active .ix-step-card h3{color:#fff}
/* split: golden record — same orbital animation as the Ledger page, scaled into the split column */
.ix-split{display:grid;grid-template-columns:1fr 1.15fr;gap:clamp(32px,5vw,72px);align-items:center}
@media(max-width:880px){.ix-split{grid-template-columns:1fr;gap:40px}}
.ix-gr-stage{position:relative;width:100%;max-width:600px;margin:0 auto;height:clamp(380px,46vw,560px)}
.ix-gr-stage canvas{position:absolute;inset:0;width:100%;height:100%;display:block}
@media(max-width:880px){.ix-gr-stage{height:clamp(340px,82vw,460px)}}
/* apex feature */
.ix-apex{display:grid;grid-template-columns:1fr auto;align-items:center;gap:clamp(24px,4vw,56px);padding:clamp(28px,3.4vw,44px);border-radius:12px;background:linear-gradient(180deg,rgba(232,217,184,0.10),rgba(34,26,66,0.55) 80%);border:1px solid rgba(232,217,184,0.35);box-shadow:0 0 54px -22px rgba(232,217,184,0.3)}
@media(max-width:760px){.ix-apex{grid-template-columns:1fr;gap:20px}}
.ix-apex-role{font-family:'JetBrains Mono',monospace;font-size:11px;letter-spacing:0.12em;text-transform:uppercase;color:var(--champ-light,#E8D9B8)}
.ix-apex h3{font-family:'Source Serif 4',serif;font-weight:500;font-size:clamp(26px,3vw,38px);color:var(--bone,#FAF8F4);margin:10px 0 12px;line-height:1.05}
.ix-apex-copy{font-family:Inter,sans-serif;font-size:15px;line-height:1.62;color:rgba(250,248,244,0.7);max-width:58ch}
.ix-apex-copy strong{color:var(--bone,#FAF8F4);font-weight:600}
.ix-apex-stat{text-align:right;flex:0 0 auto}
.ix-apex-stat .v{font-family:'Source Serif 4',serif;font-weight:400;font-size:clamp(44px,6vw,76px);line-height:1;letter-spacing:-0.02em;color:var(--bone,#FAF8F4);white-space:nowrap}
.ix-apex-stat .v .cur{font-style:italic;color:var(--champ-light,#E8D9B8)}
.ix-apex-stat .k{font-family:'JetBrains Mono',monospace;font-size:10.5px;letter-spacing:0.14em;text-transform:uppercase;color:rgba(250,248,244,0.55);margin-top:10px}
@media(max-width:760px){.ix-apex-stat{text-align:left}}
/* future carousel (institutions): horizontal slider, ~3.5 cards, full-open readable cards */
.ix-fnav{display:flex;justify-content:center;gap:14px;margin-top:clamp(26px,3vh,38px)}
.ix-fbtn{width:48px;height:48px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;border:1px solid var(--box-border,#D8D0C2);background:var(--box-fill,#FEFCF8);color:var(--aubergine,#15102A);cursor:pointer;transition:border-color .3s,background .3s,color .3s,opacity .3s,box-shadow .3s;box-shadow:0 6px 18px -12px rgba(21,16,42,0.4)}
.ix-fbtn svg{width:20px;height:20px}
.ix-fbtn:hover:not(:disabled){border-color:rgba(168,139,74,0.7);background:#fff;box-shadow:0 10px 24px -12px rgba(168,139,74,0.5)}
.ix-fbtn:disabled{opacity:0.3;cursor:not-allowed}
.ix-fbtn:focus-visible{outline:2px solid rgba(168,139,74,0.6);outline-offset:2px}
/* viewport clips, track slides; grab-to-drag */
.ix-fcar-vp{overflow:hidden}
.ix-fcar{display:flex;gap:16px;transition:transform 560ms cubic-bezier(0.22,1,0.36,1);will-change:transform;cursor:grab;touch-action:pan-y}
.ix-fcar.is-dragging{cursor:grabbing;transition:none;user-select:none}
/* each card ~28% so ~3.5 are visible */
.ix-fc{position:relative;flex:0 0 28%;min-width:0;overflow:hidden;border:1px solid var(--box-border,#D8D0C2);border-radius:16px;background:var(--box-fill,#FEFCF8);min-height:clamp(280px,34vh,340px);transition:border-color .42s,box-shadow .42s,background .42s,transform .42s}
@media(max-width:1100px){.ix-fc{flex-basis:40%}}
@media(max-width:820px){.ix-fc{flex-basis:64%}}
@media(max-width:560px){.ix-fc{flex-basis:82%}}
/* the leading visible card carries the champagne look; the rest stay clean */
.ix-fc.lead{border-color:rgba(168,139,74,0.5);background:linear-gradient(150deg,#FFFDF9,#F2E8D6 92%);box-shadow:0 26px 54px -36px rgba(168,139,74,0.5)}
.ix-fc-motif{position:absolute;right:0;bottom:0;width:58%;max-width:220px;aspect-ratio:1/1;pointer-events:none;opacity:0;transform:scale(0.94);transform-origin:bottom right;transition:opacity .6s cubic-bezier(0.22,1,0.36,1),transform .6s cubic-bezier(0.22,1,0.36,1);-webkit-mask-image:radial-gradient(120% 120% at 100% 100%,#000 36%,transparent 82%);mask-image:radial-gradient(120% 120% at 100% 100%,#000 36%,transparent 82%)}
.ix-fc.lead .ix-fc-motif{opacity:1;transform:scale(1)}
.ix-fc:not(.lead) .ix-fc-motif{opacity:0.4}
.ix-fc-motif svg{position:absolute;inset:0;width:100%;height:100%;display:block}
.ix-fc-motif svg *{stroke:#A88B4A;fill:none;stroke-width:1;vector-effect:non-scaling-stroke}
.ix-fc-motif svg .dim{opacity:0.18}.ix-fc-motif svg .mid{opacity:0.32}.ix-fc-motif svg :not(.dim):not(.mid){opacity:0.5}
.ix-fc-body{position:relative;z-index:2;height:100%;display:flex;flex-direction:column;padding:clamp(22px,1.8vw,28px)}
.ix-fc-eyebrow{font-family:'JetBrains Mono',monospace;font-size:10px;font-weight:500;letter-spacing:0.14em;text-transform:uppercase;color:#8A6E3A;margin-bottom:14px}
.ix-fc-body h3{font-family:'Source Serif 4',serif;font-weight:500;font-size:clamp(20px,1.7vw,24px);line-height:1.16;letter-spacing:-0.015em;color:var(--aubergine,#15102A);margin-bottom:12px}
.ix-fc-body p{font-family:Inter,sans-serif;font-size:14px;line-height:1.58;color:var(--on-surface-muted,#4F4538);margin:0}
/* partner minor cards */
.ix-pgrid{display:grid;grid-template-columns:repeat(4,1fr);gap:16px;margin-top:24px}
@media(max-width:900px){.ix-pgrid{grid-template-columns:repeat(2,1fr)}}
@media(max-width:520px){.ix-pgrid{grid-template-columns:1fr}}
.ix-pcard{border:1px solid rgba(232,217,184,0.14);border-radius:10px;background:rgba(34,26,66,0.4);padding:22px;transition:transform .4s cubic-bezier(0.22,1,0.36,1),border-color .4s}
.ix-pcard:hover{transform:translateY(-4px);border-color:rgba(168,139,74,0.45)}
.ix-pcard h3{font-family:'Source Serif 4',serif;font-weight:500;font-size:18px;color:var(--bone,#FAF8F4);margin-bottom:6px}
.ix-pcard p{font-family:'JetBrains Mono',monospace;font-size:10.5px;letter-spacing:0.06em;text-transform:uppercase;color:rgba(250,248,244,0.55);line-height:1.5}
/* day-surface variants (institutions partners section is light) */
.ix-apex.ix-apex-day{background:linear-gradient(180deg,rgba(232,217,184,0.28),var(--box-fill,#FEFCF8) 80%);border:1px solid rgba(168,139,74,0.4);box-shadow:0 22px 50px -34px rgba(21,16,42,0.4)}
.ix-apex-day .ix-apex-role{color:#8A6E3A}
.ix-apex-day h3{color:var(--aubergine,#15102A)}
.ix-apex-day .ix-apex-copy{color:var(--on-surface-muted,#4F4538)}
.ix-apex-day .ix-apex-copy strong{color:var(--aubergine,#15102A)}
.ix-apex-day .ix-apex-stat .v{color:var(--aubergine,#15102A)}
.ix-apex-day .ix-apex-stat .v .cur{color:#A88B4A}
.ix-apex-day .ix-apex-stat .k{color:var(--on-surface-muted,#4F4538)}
.ix-pgrid-day .ix-pcard{background:var(--box-fill,#FEFCF8);border:1px solid var(--box-border,#D8D0C2)}
.ix-pgrid-day .ix-pcard:hover{border-color:rgba(168,139,74,0.45)}
.ix-pgrid-day .ix-pcard h3{color:var(--aubergine,#15102A)}
.ix-pgrid-day .ix-pcard p{color:var(--on-surface-muted,#4F4538)}
/* aubergine night sections get the product-page purple + bronze hue gradients */
.surface-night.with-bloom{
  background-image:
    repeating-linear-gradient(135deg,rgba(255,255,255,0.014) 0,rgba(255,255,255,0.014) 1px,transparent 1px,transparent 80px),
    radial-gradient(ellipse 70% 60% at 0% 0%,rgba(76,55,120,0.30),transparent 70%),
    radial-gradient(ellipse 80% 60% at 100% 100%,rgba(168,107,61,0.20),transparent 70%);
}



/* ===== T-REX global chrome (scoped, self-contained) ===== */
.tgn,.tgf{--tgc-aub:#15102A;--tgc-aub2:#1A1531;--tgc-aub3:#221A42;--tgc-bone:#FAF8F4;
  --tgc-champ:#A88B4A;--tgc-champL:#E8D9B8;--tgc-lava:#FF7A33;
  font-family:'Inter',system-ui,-apple-system,Segoe UI,Roboto,sans-serif;box-sizing:border-box;}
.tgn *,.tgf *{box-sizing:border-box;}
.tgn{position:sticky;top:0;z-index:1000;background:rgba(21,16,42,0.90);
  -webkit-backdrop-filter:saturate(140%) blur(14px);backdrop-filter:saturate(140%) blur(14px);
  border-bottom:1px solid rgba(232,217,184,0.12);}
.tgn-bar{max-width:1240px;margin:0 auto;height:60px;padding:0 clamp(18px,4vw,40px);
  display:flex;align-items:center;justify-content:space-between;gap:24px;}
.tgn-brand{display:inline-flex;align-items:center;line-height:0;flex:0 0 auto;}
.tgn-wordmark{height:24px;width:auto;display:block;}
.tgn-links{display:flex;align-items:center;gap:clamp(6px,1.4vw,18px);}
.tgn-item{position:relative;display:flex;align-items:center;height:60px;}
.tgn-link{display:inline-flex;align-items:center;gap:5px;color:rgba(250,248,244,0.74);
  text-decoration:none;font-size:14px;font-weight:500;letter-spacing:.01em;padding:6px 4px;
  transition:color .18s ease;}
.tgn-link:hover,.tgn-item:hover .tgn-link{color:var(--tgc-bone);}
.tgn-link.tgn-active{color:var(--tgc-bone);}
.tgn-caret{font-size:9px;opacity:.7;transition:transform .2s ease;}
.tgn-item:hover .tgn-caret{transform:translateY(1px);}
.tgn-ext{font-size:11px;opacity:.7;}
.tgn-menu{position:absolute;top:58px;left:-14px;min-width:280px;padding:8px;
  background:var(--tgc-aub2);border:1px solid rgba(232,217,184,0.14);border-radius:12px;
  box-shadow:0 24px 60px -20px rgba(0,0,0,0.7);opacity:0;visibility:hidden;transform:translateY(6px);
  transition:opacity .18s ease,transform .18s ease,visibility .18s;}
.tgn-has-menu:hover .tgn-menu{opacity:1;visibility:visible;transform:translateY(0);}
.tgn-menu a{display:flex;flex-direction:column;gap:2px;padding:10px 12px;border-radius:8px;
  text-decoration:none;transition:background .15s ease;}
.tgn-menu a span{color:var(--tgc-bone);font-size:14px;font-weight:600;}
.tgn-menu a small{color:rgba(250,248,244,0.55);font-size:12px;font-weight:400;}
.tgn-menu a:hover{background:var(--tgc-aub3);}
.tgn-actions{display:flex;align-items:center;gap:12px;flex:0 0 auto;}
.tgn-cta{display:inline-flex;align-items:center;text-decoration:none;font-size:13.5px;font-weight:600;
  color:var(--tgc-aub);padding:9px 18px;border-radius:9px;white-space:nowrap;
  background:linear-gradient(180deg,#F4E9CF 0%,var(--tgc-champL) 100%);
  box-shadow:0 1px 0 rgba(255,255,255,0.4) inset,0 6px 18px -8px rgba(232,217,184,0.5);
  transition:transform .16s ease,box-shadow .16s ease;}
.tgn-cta:hover{transform:translateY(-1px);box-shadow:0 10px 24px -10px rgba(232,217,184,0.7);}
.tgn-burger{display:none;flex-direction:column;justify-content:center;gap:4px;width:40px;height:38px;
  background:transparent;border:1px solid rgba(232,217,184,0.22);border-radius:9px;cursor:pointer;padding:0 9px;}
.tgn-burger span{display:block;height:2px;width:100%;background:var(--tgc-bone);border-radius:2px;transition:transform .2s ease,opacity .2s ease;}
.tgn.tgn-open .tgn-burger span:nth-child(1){transform:translateY(6px) rotate(45deg);}
.tgn.tgn-open .tgn-burger span:nth-child(2){opacity:0;}
.tgn.tgn-open .tgn-burger span:nth-child(3){transform:translateY(-6px) rotate(-45deg);}
.tgn-panel{display:none;flex-direction:column;padding:10px clamp(18px,4vw,40px) 22px;
  background:var(--tgc-aub);border-top:1px solid rgba(232,217,184,0.1);gap:2px;}
.tgn.tgn-open .tgn-panel{display:flex;}
.tgn-acc{border-bottom:1px solid rgba(232,217,184,0.08);}
.tgn-acc summary{list-style:none;cursor:pointer;color:var(--tgc-bone);font-size:15px;font-weight:600;
  padding:14px 2px;display:flex;justify-content:space-between;align-items:center;}
.tgn-acc summary::-webkit-details-marker{display:none;}
.tgn-acc summary::after{content:"+";color:var(--tgc-champL);font-size:18px;}
.tgn-acc[open] summary::after{content:"\\2212";}
.tgn-acc a{display:block;color:rgba(250,248,244,0.7);text-decoration:none;font-size:14px;padding:9px 2px 9px 14px;}
.tgn-acc a:hover{color:var(--tgc-bone);}
.tgn-plink{display:block;color:var(--tgc-bone);text-decoration:none;font-size:15px;font-weight:600;
  padding:14px 2px;border-bottom:1px solid rgba(232,217,184,0.08);}
.tgn-pcta{display:block;text-align:center;margin-top:16px;text-decoration:none;font-size:14.5px;font-weight:600;
  color:var(--tgc-aub);padding:13px 18px;border-radius:10px;
  background:linear-gradient(180deg,#F4E9CF 0%,var(--tgc-champL) 100%);}
@media(max-width:900px){
  .tgn-links{display:none;}
  .tgn-burger{display:flex;}
  .tgn-cta{display:none;}
}
.tgf{background:var(--tgc-aub);color:rgba(250,248,244,0.72);border-top:1px solid rgba(232,217,184,0.1);}
.tgf-inner{max-width:1240px;margin:0 auto;padding:64px clamp(18px,4vw,40px) 40px;}
.tgf-wordmark{height:26px;width:auto;display:block;margin-bottom:18px;}
.tgf-tag{font-size:15px;line-height:1.5;color:rgba(250,248,244,0.7);max-width:320px;margin:0 0 20px;}
.tgf-cta{display:inline-block;color:var(--tgc-champL);text-decoration:none;font-size:14px;font-weight:600;}
.tgf-cta:hover{color:var(--tgc-bone);}
.tgf-cols{display:grid;grid-template-columns:repeat(4,1fr);gap:28px;}
.tgf-col h4{color:var(--tgc-bone);font-size:12px;font-weight:600;letter-spacing:.12em;text-transform:uppercase;margin:0 0 14px;}
.tgf-col a{display:block;color:rgba(250,248,244,0.6);text-decoration:none;font-size:14px;padding:6px 0;transition:color .15s ease;}
.tgf-col a:hover{color:var(--tgc-bone);}
.tgf-top{display:grid;grid-template-columns:1.3fr 2fr;gap:48px;}
.tgf-base{display:flex;justify-content:space-between;align-items:flex-start;gap:24px;flex-wrap:wrap;
  margin-top:48px;padding-top:24px;border-top:1px solid rgba(232,217,184,0.1);}
.tgf-base p{margin:0;font-size:12.5px;color:rgba(250,248,244,0.5);}
.tgf-legal{max-width:560px;text-align:right;}
@media(max-width:820px){
  .tgf-top{grid-template-columns:1fr;gap:36px;}
  .tgf-cols{grid-template-columns:repeat(2,1fr);}
  .tgf-base{flex-direction:column;}
  .tgf-legal{text-align:left;}
}


.surface-night .accent-italic{color:#E8D9B8}


/* uniform section gap on every page (fixed px, no vh/rem drift) */
.section,.surface-day,.surface-night,
.proof,.pillars-inner,.hiw-inner,.whofor-inner,.apex-inner,.closer-inner{
  padding-top:80px!important;padding-bottom:80px!important}
@media(max-width:768px){
.section,.surface-day,.surface-night,
.proof,.pillars-inner,.hiw-inner,.whofor-inner,.apex-inner,.closer-inner{
  padding-top:52px!important;padding-bottom:52px!important}}

`;
